import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SuccessFeedbackDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <CheckCircleIcon 
                        sx={{ 
                            fontSize: 60, 
                            color: '#39B54A' 
                        }} 
                    />
                </Box>
                <Typography variant="h6" fontWeight={600}>
                    Driver configuration is <strong>completed</strong> successfully
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        bgcolor: '#39B54A',
                        '&:hover': { bgcolor: '#2d9140' },
                        minWidth: 120,
                    }}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SuccessFeedbackDialog;
